/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Faq_Release_QInputs */

const en_mk_tb_faq_release_q = /** @type {(inputs: Mk_Tb_Faq_Release_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does an accepted task automatically deploy?`)
};

const id_mk_tb_faq_release_q = /** @type {(inputs: Mk_Tb_Faq_Release_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah tugas yang diterima otomatis di-deploy?`)
};

/**
* | output |
* | --- |
* | "Does an accepted task automatically deploy?" |
*
* @param {Mk_Tb_Faq_Release_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_faq_release_q = /** @type {((inputs?: Mk_Tb_Faq_Release_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Faq_Release_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_faq_release_q(inputs)
	return en_mk_tb_faq_release_q(inputs)
});